import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { JeevesProductDetailsComponent } from 'gung-standard-jeeves';
import {
  ProductService,
  AvailabilityService,
  AuthService,
  PriceService,
  GungFlowService,
  BaseViewConfigService,
  MetadataService,
  AssortmentService
} from 'gung-standard';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'cult-product-details',
  templateUrl: './cult-product-details.component.html',
  styleUrls: ['./cult-product-details.component.scss']
})
export class CultProductDetailsComponent extends JeevesProductDetailsComponent implements OnInit {
  isReturnFlow = false;

  ngOnInit(): void {
    super.ngOnInit();
    this.gungFlowService
      .getSelectedFlow()
      .pipe()
      .subscribe(flow => {
        if (flow.isReturnOrder) {
          this.isReturnFlow = true;
        }
      });
  }

  getProductDescription(): Observable<string> {
    const lang = this.translateService.currentLang || 'se';

    let description = '';
    if (this.product?.extra?.i18n && this.product?.extra?.i18n[lang]) {
      description = this.product.extra.i18n[lang].description || '';
    }
    if (this.product?.extra?.i18n && this.product?.extra?.i18n[lang]) {
      description = this.product.extra.i18n[lang].descriptionHtml || '';
    }

    return of(description);
  }
}
